'use client'

import { useScrollEdgeFade } from '~/hooks/useScrollEdgeFade'

/**
 * Caps filter popover content to a scrollable area with top/bottom edge
 * fades, mirroring the sidebar accounts list.
 */
export const FilterScrollFade = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { containerProps, startOpacity, endOpacity } = useScrollEdgeFade({
    orientation: 'vertical',
  })

  return (
    // Negative margins offset PopoverContent's p-4 and the popover's gaps so
    // the scrollbar hugs the popover edge; px-4 restores the content inset.
    <div
      {...containerProps}
      className="-mx-4 -mb-3 -mt-3 max-h-72 overflow-y-auto px-4"
    >
      {/* Sticky fades inside the scroll container so they never paint over
          the scrollbar; the top one doubles as the scroll area's top padding. */}
      <div aria-hidden className="pointer-events-none sticky top-0 z-10 h-3">
        <div
          style={{ opacity: startOpacity }}
          className="absolute -inset-x-4 top-0 h-5 bg-gradient-to-b from-white to-transparent dark:from-gray-900"
        />
      </div>
      {children}
      <div aria-hidden className="pointer-events-none sticky bottom-0 z-10 h-0">
        <div
          style={{ opacity: endOpacity }}
          className="absolute -inset-x-4 bottom-0 h-5 bg-gradient-to-t from-white to-transparent dark:from-gray-900"
        />
      </div>
    </div>
  )
}
